import React from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import get from 'lodash/get'
import { InjectHtml } from '@/components/ui'
import type { IConditionsTableProps } from '../interfaces'
import { messages } from '../messages'

const ConditionsTableDesktop: React.FC<IConditionsTableProps> = props => {
  const { conditionsTable = [], blockId: gtmBlockId, tableTitleId, shouldMarkFirstRow, className } = props

  return (
    <div
      className={classNames(`page-wrapper ${className}`, {
        'space-holder-top128': !className,
      })}
    >
      <span />
      {tableTitleId && <InjectHtml TagName="h2" textId={tableTitleId} className="space-holder40" />}
      <div className="landing-constructor-conditions-table space-holder80">
        {conditionsTable.map(({ captionId, isInnerHeading, values }, rowIndex) => {
          const valuesLength = values.length
          const isMarkedFirstRow = rowIndex === 0 && shouldMarkFirstRow

          return (
            <section
              className={classNames('landing-constructor-conditions-table-row', {
                'landing-constructor-conditions-table-row_low': isInnerHeading,
                'landing-constructor-conditions-table-row_marked-first': isMarkedFirstRow,
              })}
              key={captionId}
            >
              <h5
                className={classNames('landing-constructor-conditions-table-row__caption', {
                  'h4 background_green color_white': isMarkedFirstRow,
                  'landing-constructor-conditions-table-row__inner-heading': isInnerHeading,
                })}
              >
                {captionId && <FormattedMessage id={get(messages.caption, captionId)} />}
              </h5>
              {values.map(({ descriptions }, index) => (
                <div
                  key={index}
                  className={classNames('landing-constructor-conditions-table-row-content', {
                    'landing-constructor-conditions-table-row__inner-heading': isInnerHeading,
                  })}
                  // 216 - ширина заголовка поделенная на количество блоков-контента для правильной ширины
                  style={{ width: `calc(${100 / valuesLength}% - ${216 / valuesLength}px)` }}
                >
                  {descriptions.map(({ textId, titleId, noticeId }) => (
                    <React.Fragment key={textId || titleId}>
                      {titleId && (
                        <h5 className={classNames('landing-constructor-conditions-table-row-title', { h4: isMarkedFirstRow })}>
                          <FormattedMessage id={get(messages.title, titleId)} />
                        </h5>
                      )}

                      {(textId || noticeId) && (
                        <InjectHtml
                          textId={get(messages.text, textId || noticeId || '')}
                          className={classNames('landing-constructor-conditions-table-row-description', {
                            'text_super-small color_pale-black': Boolean(noticeId) && !textId,
                          })}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              ))}
            </section>
          )
        })}
      </div>
      {/* useBlocksIntersectionWhenScrollingDown не работает с компонентами,
      у которых высота больше высоты вьюпорта (при threshold === 1 )*/}
      <span id={gtmBlockId} />
    </div>
  )
}

export default ConditionsTableDesktop
